<div class="record-interactions">
  <app-rating
    *ngIf="rating"
    class="record-interactions__rating"
    [record]="record"
    [rating]="rating"
    [readOnly]="readOnly"
    (rated)="onRecordRated($event)"></app-rating>

  <div>
    <app-favorite-button [record]="record" [ngClass]="textDirection"></app-favorite-button>
    <app-add-to-list-button [record]="record"></app-add-to-list-button>

    <button
      *ngIf="showWikipediaLink"
      mat-flat-button
      class="only-icon"
      (click)="goToWikipedia(record.author)"
      [attr.aria-label]="('general.goto' | translate) + ' Wikipedia'"
      [opacTooltip]="('general.goto' | translate) + 'Wikipedia'">
      <span class="odilo-icon" aria-hidden="true">wikipedia</span>
    </button>

    <app-share-button
      *ngIf="showSocialIcons"
      [include]="socialButtons"
      [title]="record.title"
      [description]="shareText"></app-share-button>

    <opac-button
      *ngIf="showReportIssueButton"
      class="report-issue-button"
      [ariaLabel]="'report.title' | translate" [opacTooltip]="'report.title' | translate"
      (click)="openReportDialog()">
      <opac-icon slot="only-icon" icon="report_problem"></opac-icon>
    </opac-button>

    <app-citation-button *ngIf="record.citable" [record]="record"></app-citation-button>
  </div>
</div>
